import axios from 'axios';
axios.defaults.withCredentials = true;

const service= axios.create({
    baseURL: 'https://dapp.dream-space.top',
    timeout: 10000,
    headers: {
        get: {
          'Content-Type': 'application/json;charset=utf-8'
        },
        post: {
          'Content-Type': 'application/json;charset=utf-8'
        }
    }
});
service.interceptors.request.use(config => {
    let address = sessionStorage.getItem('address');
    address && (config.headers.token = address);
    return config; 
 }, error => {
     return Promise.reject(error);
 });

 service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        return Promise.reject(error);
    }
);
export default service;
